import { CustomField, isCustomFieldValueEmpty } from 'utils/customFields';

/** Returns warning message (if necessary) to be used in fields. */
export function getConversationCustomFieldsFormWarningMessage(
  customField: CustomField,
  isAcw: boolean,
): string | undefined {
  if (
    isAcw &&
    customField.attribute.is_required &&
    isCustomFieldValueEmpty(customField.value)
  ) {
    return 'Please fill in this required attribute';
  }
}
